import { FertilizerResponse, FertilizerMapResponse, FertilizerWarehouseResponse } from './types';
import { agroApi } from "../../../../redux/api/api";

export const fertilizerApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getFertilizerData: builder.query<FertilizerResponse, { year?: string; regionId: number | null }>({
      query: ({ year, regionId }) => ({
        url: '/departments/chemicalization/fertilizer-usage/analytical-data/on-map',
        method: 'GET',
        params: {
          ...(year && { year }),
          ...(regionId !== null && { regionId })
        }
      }),
      keepUnusedDataFor: 0,
    }),

    getFertilizerOnMap: builder.query<FertilizerMapResponse, { year?: string; regionId: number | null }>({
      query: ({ year, regionId }) => ({
        url: '/departments/chemicalization/fertilizer-usage/analytical-data/by-fertilizer-on-map',
        method: 'GET',
        params: {
          ...(year && { year }),
          ...(regionId !== null && { regionId })
        }
      }),
      keepUnusedDataFor: 0,
    }),

    getFertilizerwarehouseData: builder.query<FertilizerWarehouseResponse, { year?: string }>({
      query: ({ year }) => ({
        url: '/departments/chemicalization/fertilizer-usage/analytical-data/fertilizer-warehouse',
        method: 'GET',
        params: {
          ...(year && { year }),
        }
      }),
      keepUnusedDataFor: 0,
    })
  })
});

export const { 
  useGetFertilizerDataQuery,
  useGetFertilizerOnMapQuery,
  useGetFertilizerwarehouseDataQuery
} = fertilizerApi;